$(document).ready(function () {
    if ($(".id--3").length) {
        const shopDataLayer = getShopDataLayer();

        $(".empty-content h2").html(shopDataLayer.emptyContent.subtitle);
        $(".empty-content p").first().html(shopDataLayer.emptyContent.text);
    }
})